var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrashcaninline = function SvgTrashcaninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0 5 .947H1c-.552 0-1 .425-1 .948 0 .523.448.947 1 .947h14c.552 0 1-.424 1-.947 0-.523-.448-.948-1-.948h-4L10 0H6ZM1 5v11.105C1 17.147 1.9 18 3 18h10c1.1 0 2-.853 2-1.895V5H1Zm4.41 3.024c.255 0 .51.091.705.276L8 10.085 9.885 8.3a1.037 1.037 0 0 1 1.41 0 .91.91 0 0 1 0 1.335L9.41 11.421l1.885 1.786a.91.91 0 0 1 0 1.336 1.038 1.038 0 0 1-1.41 0L8 12.757l-1.885 1.786a1.038 1.038 0 0 1-1.41 0 .91.91 0 0 1 0-1.336L6.59 11.42 4.705 9.635a.91.91 0 0 1 0-1.335c.195-.185.45-.276.705-.276Z",
    fill: "#000"
  })));
};
export default SvgTrashcaninline;